import { useSelector } from 'react-redux';

import { selectSubscriptionLicensePack } from 'modules/Subscriptions/detail/selectors';

export function useLicensePack() {
  const licensePack = useSelector(selectSubscriptionLicensePack);
  return licensePack;
}
